import { IIndustryType } from "./types";

export const businessPlanQueryKeys = {
  businessPlans: () => ['businessPlans'],
  businessPlan: (id: string) => [...businessPlanQueryKeys.businessPlans(), id],
  businessPlansLimits: () => [...businessPlanQueryKeys.businessPlans(), 'limits'],
  accessUsers: (id: string) => [...businessPlanQueryKeys.businessPlan(id), 'accessUsers'],
  businessPlanIndustryPictures: (type: IIndustryType) => [...businessPlanQueryKeys.businessPlan(type), 'industryPictures'],
  businessPlanPublicStatus: (id: string) => [...businessPlanQueryKeys.businessPlan(id), 'publicStatus'],
  onePagePublicPlan: (id: string) => [...businessPlanQueryKeys.businessPlan(id), 'onePagePublicPlan'],
  getBusinessPlanPDFBinary: (id: string) => [...businessPlanQueryKeys.businessPlan(id), 'pdfBinary'],
};
